import React from 'react'
import { IconinfoCircle } from '@yy/one-icon'
import styles from './index.module.less'

interface AlertProps {
  message?: React.ReactNode
  style?: React.CSSProperties
}

export const Alert: React.FC<AlertProps> = ({ message, style }) => {
  return (
    <div className={styles.alert} style={style}>
      <IconinfoCircle />
      {message}
    </div>
  )
}

Alert.displayName = 'Alert'
